import { render, staticRenderFns } from "./Picture_release.vue?vue&type=template&id=6ec61eb0&style=true"
import script from "./Picture_release.vue?vue&type=script&lang=js"
export * from "./Picture_release.vue?vue&type=script&lang=js"
import style0 from "./Picture_release.vue?vue&type=style&index=0&id=6ec61eb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports